import React from 'react';

/**
 * Shown to a guest once they've built up enough progress that losing it would
 * sting. Deliberately not a wall: "Keep swiping" is a real, equal-weight exit,
 * and dismissing it is remembered so it never nags twice.
 */
const SaveProgressModal = ({ cardCount, onCreateAccount, onSignIn, onDismiss }) => {
    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="save-progress-title"
            style={{
                position: 'fixed',
                inset: 0,
                backgroundColor: 'var(--overlay)',
                zIndex: 2000,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '20px',
                fontFamily: 'var(--body)',
            }}
        >
            <div style={{
                backgroundColor: 'var(--surface)',
                padding: 'clamp(20px, 5vw, 30px)',
                borderRadius: 'var(--r-xl)',
                maxWidth: 'min(380px, calc(100vw - 40px))',
                width: '100%',
                textAlign: 'center',
                border: 'var(--border)',
                boxShadow: 'var(--sh-lg)',
                boxSizing: 'border-box',
            }}>
                <div style={{
                    width: '64px',
                    height: '64px',
                    margin: '0 auto 18px',
                    borderRadius: '18px',
                    background: 'var(--lime)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '30px',
                    fontWeight: 'bold',
                    color: 'var(--text)',
                }}>
                    {cardCount}
                </div>

                <h2 id="save-progress-title" style={{
                    fontSize: '22px',
                    color: 'var(--text)',
                    margin: '0 0 12px 0',
                    fontWeight: 'bold',
                }}>
                    Nice work — keep it?
                </h2>

                <p style={{
                    color: 'var(--text-soft)',
                    fontSize: '15px',
                    lineHeight: '1.6',
                    marginBottom: '24px',
                }}>
                    You've worked through <strong style={{ color: 'var(--text)' }}>{cardCount} cards</strong>.
                    Create a free account and they'll be waiting for you next time — on any device.
                </p>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <button
                        onClick={onCreateAccount}
                        style={{
                            width: '100%',
                            minHeight: '48px',
                            padding: '14px',
                            borderRadius: 'var(--r-md)',
                            border: 'var(--border)',
                            boxShadow: 'var(--sh)',
                            background: 'var(--lime)',
                            color: 'var(--text)',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                    >
                        Create a free account
                    </button>

                    <button
                        onClick={onSignIn}
                        style={{
                            width: '100%',
                            minHeight: '44px',
                            padding: '12px',
                            borderRadius: 'var(--r-md)',
                            border: 'var(--border)',
                            background: 'var(--surface-2)',
                            color: 'var(--text)',
                            fontSize: '15px',
                            fontWeight: '500',
                            cursor: 'pointer',
                        }}
                    >
                        I already have one
                    </button>

                    <button
                        onClick={onDismiss}
                        style={{
                            width: '100%',
                            minHeight: '44px',
                            padding: '12px',
                            border: 'none',
                            background: 'none',
                            color: 'var(--text-soft)',
                            fontSize: '14px',
                            cursor: 'pointer',
                        }}
                    >
                        Keep swiping
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SaveProgressModal;
